"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _light = _interopRequireDefault(require("./light"));

var _dark = _interopRequireDefault(require("./dark"));

var _compact = _interopRequireDefault(require("./compact"));

var _comfortable = _interopRequireDefault(require("./comfortable"));

var _base = _interopRequireDefault(require("./base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createPrismaTheme(_ref) {
  var colorScheme = _ref.colorScheme,
      density = _ref.density;
  var colorSchemeVars = {
    light: _light["default"],
    dark: _dark["default"]
  }[colorScheme];
  var densityVars = {
    compact: _compact["default"],
    comfortable: _comfortable["default"]
  }[density];
  var prismaBase = (0, _base["default"])({
    colorScheme: colorScheme
  });
  return _objectSpread(_objectSpread(_objectSpread({}, prismaBase), colorSchemeVars), densityVars);
}

var _default = createPrismaTheme;
exports["default"] = _default;